import { gql } from "@apollo/client";

export default gql`
  query getGoalOverviewSelectedEntityQuery(
    $teamId: Int!
    $userId: Int!
    $organizationId: Int!
    $hasTeamId: Boolean!
    $hasUserId: Boolean!
    $hasOrganizationId: Boolean!
  ) {
    user(userId: $userId) @include(if: $hasUserId) {
      id
      email
      name
      avatar
    }
    team(teamId: $teamId) @include(if: $hasTeamId) {
      id
      title
    }
    organization(pk: $organizationId) @include(if: $hasOrganizationId) {
      id
      name
    }
    userArtifacts: artifacts(
      artifactType: goal
      goalStates: [open, draft]
      goalOwners: [$userId]
    ) @include(if: $hasUserId) {
      totalCount
    }
    teamArtifacts: artifacts(
      artifactType: goal
      goalStates: [open, draft]
      goalScopes: team
      goalTeams: [$teamId]
    ) @include(if: $hasTeamId) {
      totalCount
    }
    organizationArtifacts: artifacts(
      artifactType: goal
      goalStates: [open, draft]
      goalScopes: organization
      organizationId: $organizationId
    ) @include(if: $hasOrganizationId) {
      totalCount
    }
  }
`;
